import { Box, Card, CardContent, Chip, FormControl, InputLabel, MenuItem, Paper, Select, Tooltip, Typography } from '@mui/material'
import { DataGrid, getGridStringOperators } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import CustomPagination from '../../../components/pagination/CustomPagination';
import Loading from '../../../components/Loader/Loading';
import { useForm, FormProvider, Controller, set } from 'react-hook-form';
import { formatDateTime } from '../../../utils/dateUtils';
import { BookingService } from '../../Booking/Service';
import Swal from 'sweetalert2';
import { NoRowsLayout } from '../../../components/NoRows/NoRowsLayout';

dayjs.extend(customParseFormat);

const statusOptions = [
  'requested',
  'accepted',
//   'rejected',
//   'completed',
  'ongoing',
//   'cancelled'
];
const BookingScheduled = () => {
    const navigate = useNavigate();
    
      /* ....................booking table related..................... */
      const[isLoading,setIsLoading] = useState(true);
      const [selectedBookingDetails,setSelectedBookingDetails] = useState(null);
    
      // Get only the 'contains' operator and make it non-removable
      const containsOnlyOperator = getGridStringOperators()
        .filter(operator => operator.value === 'contains')
        .map(operator => ({
        ...operator,
        requiresOperator: false,
        InputComponent: operator.InputComponent,
        // Hide the operator component completely
        HeaderComponent: null,
        // Remove the operator label
        headerLabel: null,
        // Hide the operator selector
        showOperatorSelector: false
      }));
      const columns = [
        // { 
        //   field: 'id', 
        //   headerName: '#S.No.', 
        //   // headerAlign:'center',
        //   flex: .75,
        //   filterable:false,
        //   renderCell: (params) => (
        //     <Typography variant="body2" sx={{fontSize:'.65rem'}} fontWeight="600" color={'#3e3e3e'}>
        //       {params.value}
        //     </Typography>
        //   ),
        // },
        { 
          field: 'bookingNumber', 
          headerName: 'Booking ID', 
          // headerAlign:'center',
          flex: 1.5,
          filterOperators: containsOnlyOperator,
          renderCell: (params) => (
            // <Typography variant="body2" color="primary" sx={{fontSize:'.65rem',cursor:'pointer'}} onClick={()=>setSelectedBookingDetails(params.row)}>
            //   #{params.value}
            // </Typography>
            <Box>
              <Typography variant="body2" color="primary" sx={{fontSize:'.65rem',cursor:'pointer'}} onClick={()=>window.open(`/admin/booking-details/${params.row.id}`,'_blank')}>
                #{params.value}
              </Typography>
              {params.row?.isTestBooking && <Chip
                label={params.row?.isTestBooking && 'Test Booking'}
                size="small"
                sx={{
                  fontWeight:'500',
                  fontSize:'x-small',
                  color: '#ffffff',
                  bgcolor:'#000000'
                }}
              />}
            </Box>
          ),
        },
          {
            field: 'serviceDate',
            headerName: 'Service Date',
            // headerAlign:'center',
            flex: 1.25,
            filterOperators: containsOnlyOperator,
            valueGetter: (params) => {
              return generateSearchableDateFormats(params.row?.serviceDate);
            },
            renderCell: (params) => (
              <Box>
                <Typography variant="body2" sx={{fontSize:'.65rem'}} >
                  {formatDateTime(params.row?.serviceDate, 'date')},
                </Typography>
                <Typography variant="body2" sx={{fontSize:'.65rem'}}>
                  {`${dayjs(params.row.bookingStartTime, 'HH:mm:ss').format('h:mm A')} - ${dayjs(params.row.bookingEndTime, 'HH:mm:ss').format('h:mm A')}`}
                </Typography>
              </Box>
            ),
          },
        // {
        //   field: 'timeSlot',
        //   headerName: 'Time Slot',
        //   // headerAlign:'center',
        //   flex: 1.8,
        //   filterable:false,
        //   renderCell: (params) => (
        //     <Typography variant="body2" sx={{fontSize:'.65rem'}}>
        //       {`${dayjs(params.row.bookingStartTime, 'HH:mm:ss').format('h:mm A')} - ${dayjs(params.row.bookingEndTime, 'HH:mm:ss').format('h:mm A')}`}
        //     </Typography>
        //   ),
        // },
        {
          field: 'providerName',
          headerName: 'Expert',
          // headerAlign:'center',
          sortable: false,
          width: 150,
          filterOperators: containsOnlyOperator,
          renderCell: (params) => (
            <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'left' }}>
              <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
            </Box>
          ),
        },
        {
          field: 'bookingItems',
          headerName: 'Requested Services',
          flex: 3,
          filterable: false,
          sortable:false,
          renderCell: (params) => {
            // Get all services from the first booking item
            // const services = params.value[0]?.serviceName.split('+').map(s => s.trim());
             const services = params.value;
            if (!services?.length) return null;
        
            const primaryService = services[0];
            const additionalServices = services.slice(1);
            
            return (
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
              }}>
                <Typography sx={{fontSize:'.65rem'}}>
                  {primaryService?.serviceName}
                </Typography>
                {services.length > 1 && (
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          padding: '0',
                          bgcolor: 'transparent'  // if you also want to remove background
                        }
                      }
                    }}
                    title={
                      <Paper sx={{ p: 1 }}>
                        {services.map((service, index) => (
                          index!=0 && <Box key={index}>
                          <Typography variant="caption" sx={{whiteSpace: 'wrap' }}>
                            {service?.serviceName}
                          </Typography>
                          <br/>
                          </Box>
                        ))}
                      </Paper>
                    }
                    placement="bottom-start"  // You can change this to any valid placement
                    PopperProps={{
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, -10], // Horizontal and vertical offset
                          },
                        },
                      ],
                    }}
                    enterDelay={200}
                    leaveDelay={200}
                  >
                    <Chip 
                      label={`+${services.length - 1}`}
                      size="small"
                      sx={{
                        height: 20,
                        backgroundColor: 'primary.ight',
                        color: 'error',
                        cursor:'pointer',
                        fontSize: '0.65rem',
                        '&:hover': {
                          backgroundColor: 'primary.dark',
                          color:'#fff'
                        }
                      }}
                    />
                  </Tooltip>
                )}
              </Box>
            );
          }
        },
        {
          field: 'bookingStatus',
          headerName: 'Status',
          // headerAlign:'center',
          flex: 1.2,
          filterOperators: containsOnlyOperator,
          sortable:false,
          renderCell: (params) => (
            <Chip
              label={params.value}
              size="small"
              sx={{
                fontWeight:'500',
                fontSize:'x-small',
                color:params.value === 'requested' ? '#E8832A' : params.value === "rejected"?'#F80000':params.value === 'completed'?'#009EB4':params.value === 'accepted'?'#40B962': params.value === 'cancelled'?'#D81A23':params.value === 'ongoing'?'#1A44B8':'default',
                bgcolor:params.value === 'requested' ? '#FFEDD5' : params.value === "rejected"?'#f800001f':params.value === 'completed'?'#009eb41a':params.value === 'accepted'?'#40b96236':params.value === 'cancelled'?'#d81a231f':params.value === 'ongoing'?'#1a44b838': 'default'
              }}
            />
          ),
        },    
        {
          field: 'amount',headerName: 'Amount',flex:1,filterable:false,sortable:false,
          renderCell: (params) => (
            // <Badge
            //   badgeContent={params.row?.payment?.status == 'PENDING' ? 'P':params.row?.payment?.paymentMethod == 'CASH'? 'C':'O'}
            //   color={params.row?.payment?.status == 'PENDING' ? 'warning':params.row?.payment?.paymentMethod == 'CASH'? 'primary':'success'}
            //   anchorOrigin={{
            //     vertical: 'center',
            //     horizontal: 'right',
            //   }}
            //   overlap="rectangular"
            //   sx={{ 
                
            //     '& .MuiBadge-badge': {
            //       fontSize: '.4rem',
            //       height: 8,
            //       minWidth: 7.5,
            //       borderRadius: 8,
            //       padding: '2px 2px',
            //     },
            //     // '& .MuiBadge-dot': {
            //     //   width: 8,
            //     //   height: 8,
            //     //   borderRadius: '50%',
            //     // }
            //   }}
            // >
            //   <Typography variant="body2" sx={{fontSize:'0.6rem',color:'#000000de'}}>₹ {params.row.total}</Typography>
              
            // </Badge>
            <Box sx={{display:'flex',alignItems:'center',gap:.5 }}>
              <Typography variant="body2" sx={{fontSize:'0.6rem',color:'#000000de'}}>₹ {params.row.total}</Typography>
              <Tooltip
                title={params.row?.payment?.status == 'PENDING' ? 'PENDING':params.row?.payment?.paymentMethod == 'CASH'? 'CASH':'Online'}
                placement="right" arrow
              >
                <Typography variant="body2" 
                  sx={{
                    fontSize:'0.6rem',
                    color:'#000000de',
                    bgcolor:params.row?.payment?.status == 'PENDING' ? '#ed6c02':params.row?.payment?.paymentMethod == 'CASH'? '#1976d2':'#2e7d32',
                    color:'#fff',
                    borderRadius:'50%',
                    width:'1rem',
                    height:'1rem',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    // ml:'.5%',
                    fontWeight:'500'
                  }}
                > 
                  {params.row?.payment?.status == 'PENDING' ? 'P':params.row?.payment?.paymentMethod == 'CASH'? 'C':'O'}
                </Typography>
              </Tooltip>
              {/* <Chip
                label={params.row?.payment?.status == 'PENDING' ? 'P':params.row?.payment?.paymentMethod == 'CASH'? 'C':'O'}
                size="small" 
                sx={{
                  width:'fit-content',
                  height:'fit-content',
                  ml:1,
                  p:0,  
                  fontWeight:'500',
                  fontSize:'0.6rem',
                  
                }}
              /> */}
            </Box>
          ),
        },
        {
          field: 'createdAt',headerName: 'Booked On',flex:1,filterable:false,
          renderCell: (params) => (
            <Typography variant="body2" sx={{fontSize:'0.6rem',color:'#000000de'}}>{formatDateTime(params.row.createdAt)}</Typography>
          ),
        },
        // {
        //   field: 'action', headerName: 'Details', flex:.75, sortable: false, 
        //   filterable:false,
        //   renderCell: (params) => {
        //     const currentRow = params.row;
        //       return (
        //         <Box className='flex items-center justify-center h-full'>
        //           <IconButton size='small' color='info' onClick={()=>setSelectedBookingDetails(currentRow)}><RemoveRedEyeIcon sx={{fontSize:'0.85rem'}} /></IconButton>
        //         </Box>
        //       );
        //   },
        // },
      ];
    
      // State to store the total row count inititally before server respond
      const [rowCount, setRowCount] = useState(5); 
        
      // State to store the row count used by the DataGrid
      const [rowCountState, setRowCountState] = useState(rowCount);
        
      // Update rowCountState whenever rowCount changes
      useEffect(() => {
        setRowCountState((prevRowCountState) =>
          rowCount !== undefined ? rowCount : prevRowCountState,
        );
      }, [rowCount, setRowCountState]);
    
    
      // State to store the rows fetched from the server
      const [rowData, setRowData] = useState([]);
    
      const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
        filters: {
          searchKey: "",
          sortKey:'createdAt',
          sortDirection:'desc',//asc,desc
          status: statusOptions,
          filterOptions: [
            {fieldName: "isTester", operator: "equals", value: 'false'},                 
            {fieldName: 'isTestBooking', operator: 'equals', value: 'false', andOr: 'and'},
            //for today
            {fieldName: 'serviceDate', operator: 'equals', value: dayjs(new Date()), andOr: 'and'}
            //for upcoming
            // {fieldName: 'serviceDate', operator: 'greaterThan', value: dayjs(new Date()), andOr: 'and'}
          ] 
        }
      });
    
      const handlePaginationModel = (newPagination) => {
        setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
      }
    
      // Effect to fetch row count and rows when paginationModel changes
      useEffect(()=>{
        const getData = async () => {
          try {
            
            setIsLoading(true)
            const urlParams = paginationModel.filters.status.map(status => `bookingStatus=${status}`).join('&');
            const listResponse = await BookingService.bookingList({
              page: paginationModel.page,
              limit: paginationModel.pageSize,
              filters: {
                searchKey: paginationModel.filters.searchKey,   // Use the title filter from the paginationModel
                status: urlParams,
                sortKey:paginationModel.filters.sortKey,
                sortDirection:paginationModel.filters.sortDirection,
                filterOptions: paginationModel.filters.filterOptions || []
              }
            });
            // console.log("booking list Response:",listResponse);
            // setValue('status', paginationModel.filters.status)
            if (listResponse.success =="1") {
              setRowData(listResponse.data.list);
              setRowCount(listResponse.data.totalItems);
              console.log("booking list data length:",listResponse.data.list.length);
            } 
            // else {
            //   Swal.fire('Request failed','','error')
            // }
          } catch (error) {
            // console.log(error)
            Swal.fire(error.message,'','error')
          }
          setIsLoading(false)
        };
        getData();
      },[paginationModel])    
    
        /************* quick search related **************/
        const [quickFilterText, setQuickFilterText] = useState('');
         // Properly structured filter model
          const [filterModel, setFilterModel] = useState({
            items: [],
            quickFilterValues: []
          });
    
          // Update filter model when quick filter text changes
          useEffect(() => {
            setFilterModel(prevModel => ({
              ...prevModel,
              quickFilterValues: quickFilterText ? [quickFilterText] : []
            }));
          }, [quickFilterText]);
      
      /******************* Sorting model  ******************************/
      const [sortModel, setSortModel] = useState([
        {
          field: paginationModel.filters.sortKey,
          sort: paginationModel.filters.sortDirection,
        },
      ]);
    
      const handleSortingChange = (newSortModel) => {
        console.log("new sort model", newSortModel);
        if (newSortModel && newSortModel.length > 0) {
          setSortModel(newSortModel);
          setPaginationModel(prev => ({
            ...prev,
            filters: {
              ...prev.filters,
              sortKey: newSortModel[0].field,
              sortDirection: newSortModel[0].sort
            }
          }));
        }
      }
      const [scheduledTime,setScheduledTime] = useState('today');
      const handleChange =(e)=>{
        e.preventDefault();
        console.log("selected value",e.target.value);
        setScheduledTime(e.target.value);
        if(e.target.value == 'today'){
          setPaginationModel(prev => ({
            ...prev,
            filters: {
              ...prev.filters,
              filterOptions: [
                {fieldName: 'serviceDate', operator: 'equals', value: dayjs(new Date()), andOr: 'and'}
              ] 
            }
          }));
        }else if((e.target.value == 'upcoming')){
          setPaginationModel(prev => ({
            ...prev,
            filters: {
              ...prev.filters,
              filterOptions: [
                {fieldName: 'serviceDate', operator: 'greaterThan', value: dayjs(new Date()), andOr: 'and'}
              ] 
            }
          }));
        }
      }
  return (
    <Card>
        <Box sx={{p:'.5% 1%',display:'flex',justifyContent:'space-between',alignItems:"center"}}>
            <Typography sx={{flex:1,fontWeight:600,fontSize:'.85rem',color:'#3e3e3e'}}>
                Scheduled Bookings
            </Typography>
            <FormControl sx={{width:'max-content'}} variant="outlined" >
                {/* <InputLabel sx={{fontSize:'0.65rem',lineHeight: '2.4375em'}}>Selected Month</InputLabel> */}
                <Select
                    size="small"
                    value={scheduledTime}
                    onChange={handleChange}
                    sx={{
                        minHeight: '0px',
                        height: '1.6rem',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                    '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center',
                    },
                    }}
                    // label='Selected Month'
                >
                    
                    <MenuItem value='today' sx={{fontSize:'small'}}>
                        Today
                    </MenuItem>
                    <MenuItem value='upcoming' sx={{fontSize:'small'}}>
                        Upcoming
                    </MenuItem>
                </Select>
            </FormControl>
        </Box>
        <CardContent sx={{p:0,pb:'0!important',overflow:'auto'}} >
            <DataGrid
                rows={rowData}
                columns={columns.map((col) => ({
                ...col,
                flex: col.flex || 1, // Ensure columns resize dynamically
                minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
                }))}
                getRowId={(row) => row.id}
                rowCount={rowCount}
                pageSizeOptions={[5, 10, 20, 50, 100]}
                paginationModel={paginationModel}
                paginationMode="server"
                onPaginationModelChange={handlePaginationModel}

                // Add these props for page numbers
                showFirstButton={true}
                showLastButton={true}

                filterModel={filterModel}
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={handleSortingChange}
                disableMultiSort={true}

                loading={isLoading}
                getRowClassName={(params) => {
                // console.log("checking customer is deleted",params.row.customer?.deletedAt)
                // Check if customer is deleted
                if (params.row.customer?.deletedAt) {
                    return 'deleted-row';
                }
                // Keep alternating row colors for non-deleted rows
                return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }}
                
                disableColumnMenu
                disableRowSelectionOnClick
                // disableColumnFilter
                // disableColumnSelector
                disableDensitySelector
                sortingOrder={['asc', 'desc']}
                slots={{
                // toolbar: GridToolbar,
                // loadingOverlay: Loading,
                // Optionally use custom pagination
                // pagination: CustomPagination,
                  noRowsOverlay: () => <NoRowsLayout message="Bookings Not Found" />
                }}
                // slotProps={{
            //   toolbar: {
            //     showQuickFilter: true,  
            //   },
            // }}
                autoHeight
                getRowHeight={() => 'auto'}
                sx={{   
                minWidth: "100%", // Ensures DataGrid expands inside scrollable container
                "& .MuiDataGrid-root": {
                    overflowX: "auto",
                },
                // Hide default footer since we're using custom pagination
                // '& .MuiDataGrid-footerContainer': {
                //     display: 'block'
                // },
                '& .MuiDataGrid-row': {
                    '& .MuiDataGrid-cell': {
                    py:1
                    },
                    // Add styles for deleted rows
                    '&.deleted-row': {
                    backgroundColor: '#ffebee !important', // Light red background
                    '&:hover': {
                        backgroundColor: '#ffcdd2 !important', // Darker red on hover
                    }
                    }
                },           
                '& .MuiDataGrid-columnHeaders': {
                    borderBottom: '2px solid rgba(224, 224, 224, 1)',
                    borderTop: '2px solid rgba(224, 224, 224, 1)',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    p:0,
                    height: 'fit-content',
                    minHeight:'0 !important',
                    height:'2rem'
                },
                // '& .MuiDataGrid-columnHeader': {
                //   borderLeft: '1px solid rgba(224, 224, 224, 1)',
                //   '&:last-child': {
                //     borderRight: 'none',
                //   },
                // },
                '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 600,
                    color: '#3e3e3e'
                },
                
                }}
            />
        </CardContent>
    </Card>
  )
}

export default BookingScheduled
const generateSearchableDateFormats = (date) => {
  if (!date) return '';
  
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '';

  const monthNames = [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'
  ];
  const monthAbbrev = monthNames.map(m => m.substring(0, 3));
  
  const day = dateObj.getDate();
  const month = dateObj.getMonth();
  const year = dateObj.getFullYear();
  
  // Generate all possible date format combinations
  const formats = [
    // Original date string
    date,
    // ISO format
    dateObj.toISOString(),
    // DD-MM-YYYY formats
    `${day}-${month + 1}-${year}`,
    `${day.toString().padStart(2, '0')}-${(month + 1).toString().padStart(2, '0')}-${year}`,
    // DD/MM/YYYY formats
    `${day}/${month + 1}/${year}`,
    `${day.toString().padStart(2, '0')}/${(month + 1).toString().padStart(2, '0')}/${year}`,
    // Month name formats
    `${day} ${monthNames[month]}`,
    `${day} ${monthAbbrev[month]}`,
    `${monthNames[month]} ${day}`,
    `${monthAbbrev[month]} ${day}`,
    `${day} ${monthNames[month]} ${year}`,
    `${day} ${monthAbbrev[month]} ${year}`,
    // Year variations
    `${day}-${month + 1}-${year.toString().slice(-2)}`,
    `${day}/${month + 1}/${year.toString().slice(-2)}`,
  ].join(' ').toLowerCase();

  return formats;
};